export * from "./animationGroup.pure";
export * from "./animationGroup.types";
import { RegisterAnimationGroup } from "./animationGroup.pure";
RegisterAnimationGroup();
//# sourceMappingURL=animationGroup.js.map